import { loadOldPage } from '@/locallib/loadOld';
import type { EntryGenerator, PageLoad } from './$types';

export const load: PageLoad = async ({ url, params, fetch }) => {
	console.log('load url', url, { ...params });

	const reply = await loadOldPage(`index.html@page=${params.page_id}.html`, fetch);

	return { html: reply };
};

export const prerender = true;
export const ssr = true;

export const entries: EntryGenerator = async () => {
	return [
		{ page_id: '11' },
		{ page_id: '12' },
		{ page_id: '13' },
		{ page_id: '14' },
		{ page_id: '15' },
		{ page_id: '16' },
		{ page_id: '17' },
		{ page_id: '18' },
		{ page_id: '19' },
		{ page_id: '20' },
		{ page_id: '21' },
		{ page_id: '22' },
		{ page_id: '24' },
		{ page_id: '25' },
		{ page_id: '26' },
		{ page_id: '27' },
		{ page_id: '28' },
		{ page_id: '29' },
		{ page_id: '30' },
		{ page_id: '31' },
		{ page_id: '32' }

		// { path: '' },
		// { path: 'cat/1' },
		// { path: 'cat/10' }
		// { path: 'cat/11' },
		// { path: 'cat/13' },
		// { path: 'cat/15' },
		// { path: 'cat/17' },
		// { path: 'cat/18' },
		// { path: 'cat/19' },
		// { path: 'cat/2' },
		// { path: 'cat/20' },
		// { path: 'cat/21' },
		// { path: 'cat/22' },
		// { path: 'cat/23' },
		// { path: 'cat/24' },
		// { path: 'cat/25' },
		// { path: 'cat/26' },
		// { path: 'cat/27' },
		// { path: 'cat/28' },
		// { path: 'cat/29' },
		// { path: 'cat/3' },
		// { path: 'cat/30' },
		// { path: 'cat/31' },
		// { path: 'cat/32' },
		// { path: 'cat/33' },
		// { path: 'cat/34' },
		// { path: 'cat/4' },
		// { path: 'cat/5' },
		// { path: 'cat/6' },
		// { path: 'cat/7' },
		// { path: 'cat/8' },
		// { path: 'cat/9' },
		// { path: 'page/11' },
		// { path: 'page/12' },
		// { path: 'page/13' },
		// { path: 'page/14' },
		// { path: 'page/15' },
		// { path: 'page/16' },
		// { path: 'page/17' },
		// { path: 'page/18' },
		// { path: 'page/19' },
		// { path: 'page/20' },
		// { path: 'page/21' },
		// { path: 'page/22' },
		// { path: 'page/24' },
		// { path: 'page/25' },
		// { path: 'page/26' },
		// { path: 'page/27' },
		// { path: 'page/28' },
		// { path: 'page/29' },
		// { path: 'page/30' },
		// { path: 'page/31' },
		// { path: 'page/32' },
		// { path: 'view/10011' },
		// { path: 'view/10012' },
		// { path: 'view/10017' },
		// { path: 'view/10027' },
		// { path: 'view/10030' },
		// { path: 'view/10032' },
		// { path: 'view/50010' },
		// { path: 'view/50014' },
		// { path: 'view/50037' },
		// { path: 'view/50038' },
		// { path: 'view/50039' },
		// { path: 'view/50040' },
		// { path: 'view/50041' },
		// { path: 'view/50042' },
		// { path: 'view/50043' },
		// { path: 'view/50044' },
		// { path: 'view/50045' },
		// { path: 'view/50048' },
		// { path: 'view/50049' },
		// { path: 'view/5005' },
		// { path: 'view/50050' },
		// { path: 'view/50053' },
		// { path: 'view/50055' },
		// { path: 'view/50056' },
		// { path: 'view/50057' },
		// { path: 'view/5006' },
		// { path: 'view/5007' },
		// { path: 'view/5008' },
		// { path: 'view/5009' },
		// { path: 'view/1/2' },
		// { path: 'view/5005' }
		// { path: 'view/50054/6' }
	];
};
